import { GridActionsCellItem, GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import { createElement } from "react";
import { TbUserX } from "react-icons/tb";

import { useClinicArrivalTasksGridActions } from "@/stores/use-clinic-arrival-tasks-grid";

import { HotelClinicResolvedPassenger } from "../../../types";
import DetailActionsHeader from "./DetailActionsHeader";

export enum ClinicTaskDetailClickActionNames {
    PASSENGER_UNASSIGN = "PASSENGER_UNASSIGN",
}

export const clinicTaskDetailActions: {
    label: string;
    icon: React.ElementType;
    color: string;
    showInMenu?: true;
    onClick: ClinicTaskDetailClickActionNames;
    mobile: boolean;
}[] = [
    {
        label: "Yolcuyu görevden çıkar",
        icon: TbUserX,
        color: "primary" as const,
        onClick: ClinicTaskDetailClickActionNames.PASSENGER_UNASSIGN,
        showInMenu: true,
        mobile: true,
    },
];

function DetailActionsColumn({
    taskId,
    allRows,
    selectedRowIds,
}: {
    taskId: string;
    allRows: HotelClinicResolvedPassenger[];
    selectedRowIds: GridRowSelectionModel;
}): GridColDef<HotelClinicResolvedPassenger> {
    return {
        field: "actions",
        type: "actions",
        width: 60,
        cellClassName: "!px-2",
        pinnable: true,
        filterable: false,
        editable: false,
        disableColumnMenu: true,

        renderHeader: () => <DetailActionsHeader taskId={taskId} allRows={allRows} selectedRowIds={selectedRowIds} />,
        getActions: (params) => {
            const { updateShowTasksDetailUnassignDialog } = useClinicArrivalTasksGridActions();

            const clickActions: Record<ClinicTaskDetailClickActionNames, { cb: () => void; cond: boolean }> = {
                [ClinicTaskDetailClickActionNames.PASSENGER_UNASSIGN]: {
                    cb: () =>
                        updateShowTasksDetailUnassignDialog({
                            taskId,
                            listItemIds: [params.row.listItemId],
                            totalPassengers: allRows.length,
                        }),
                    cond: !params.row._isPlaceholder,
                },
            };
            return clinicTaskDetailActions
                .filter((action) => clickActions[action.onClick].cond)
                .map((action) => (
                    <GridActionsCellItem
                        icon={createElement(action.icon, { size: 14 })}
                        label={action.label}
                        onClick={clickActions[action.onClick].cb}
                        color={action.color}
                        showInMenu={action.showInMenu as true}
                        key={action.label}
                    />
                ));
        },
    };
}

export default DetailActionsColumn;
